import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useTimeOffAccess() {
  const [hasTimeOffAccess, setHasTimeOffAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (mounted) {
        setHasTimeOffAccess(user?.email?.endsWith("@smtp2go.com") ?? false);
        setIsLoading(false);
      }
    };

    check();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (mounted) {
        setHasTimeOffAccess(session?.user?.email?.endsWith("@smtp2go.com") ?? false);
      }
    });

    return () => {
      mounted = false;
      subscription.unsubscribe();
    };
  }, []);

  return { hasTimeOffAccess, isLoading };
}
